// IE 2026 09 30 / ODOO-343435: guided-тур по пути (docs/visual-forms-2026-09-30/tour_design.md ie-webscm7-2, инкремент S) — цели действий тура
// и подсветка. Модуль без внешних импортов: store, виджеты и document приходят параметрами (юнит: tests/unit/guideTarget.test.mjs).
//
// Цель действия (контракт бэка guide.tour_target): { kind: widget | cell | chip | passport_block | tab, widget, row_key, row_hint, col, tab, binding, block }.
//   - widget — виджет активной страницы (как openWidget показа: w.widget === id или w.record.id === id), элемент — W.vueObj.$el;
//   - cell — ячейка грида виджета: строка по row_key (dataItem.id), иначе по row_hint (подстрока JSON строки), колонка — binding / 'doc.'+col /
//     заголовок атрибута / заголовок колонки (как шаг edit_cell клиентских тестов, mainStore.clientTest_*: сам раннер не трогаем — ночные тесты);
//     IE 2026 10 08 / ODOO-343435 (production-сборка, Demo 6): грид — из реестра W.attrs_vueObj и по DOM через wijmo.Control.getControl (не __vueParentComponent: его нет в production);
//     строка — ещё по ключам строки (поля dataItem, условия _DLRow.where и _DLRow.row_id у DL2) и по ВИДИМОМУ тексту ключевых колонок (dataMap: uuid объекта → «ITEM-003»);
//     колонка — ещё период 'YYYY-MM' / 'YYYY-MM-DD' [+ '.мера'] к колонкам DL2 '<YYYY-MM-DD>.<мера>' (первая видимая); у строки блока без значения в колонке — первая строка блока со значением;
//   - chip — чипс шапки стола (элемент с data-binding / текстом заголовка чипса), best effort;
//   - tab / passport_block — пока виджет целиком (подсветка вкладки / блока паспорта — M).
// Подсветка — fixed-рамка поверх элемента + подсказка с текстом шага; позиция перечитывается по таймеру (прокрутка / перестроение), элемент ушёл
// из DOM — рамка прячется. Всё — только DOM: ни запросов к бэку, ни записи стола (правило 13).

const isObj = (x) => !!(x && typeof x === 'object')
const str = (v) => (v === undefined || v === null) ? '' : String(v)
const defaultSleep = (ms) => new Promise(res => setTimeout(res, ms))

// ======================================================================= виджет
export function guideTarget_findWidget(store, target) {
    const id = str(target?.widget)
    const WS = store?.activeWORKSPACE
    if (!id || !WS) return null
    return (WS.ALL_WIDGETS || []).find(w => w && !w.close && w.page === WS.active_page && (w.widget === id || str(w.record?.id) === id)) || null
}
export function guideTarget_widgetEl(W) {
    const el = W?.vueObj?.$el
    return el && el.nodeType === 1 ? el : null
}

// ======================================================================= грид и ячейка
// IE 2026 10 08 / ODOO-343435: грид виджета — production-safe. Прежний поиск шёл через el.__vueParentComponent, а его Vue ставит только в dev / devtools-сборке: в production-бандле грид
// не находился, и подсвечивался виджет целиком. Источники теперь: (1) реестр компонентов виджета W.attrs_vueObj (AttrGrid: flex + attr + attr_by_binding; этим же реестром читаются
// вкладки, guideTarget_openTab); (2) DOM — хосты .wj-flexgrid → Control.getControl(host): ctx.getControl отдаёт стор (wjcCore.Control.getControl), нет — глобальный wijmo, как в AppTopbar.
// Берётся самый длинный по строкам (как mainStore.clientTest_grid); { flex, attr_by_binding }
const isGridLike = (f) => !!(f && f.rows && f.columns)   // IE 2026 10 08 / ODOO-343435
const colVisible = (c) => !!c && c.visible !== false && c.isVisible !== false   // IE 2026 10 08 / ODOO-343435: isVisible=false — колонка свёрнута группой шапки (ширина 0), visible при этом true
function controlGetter(ctx) {   // IE 2026 10 08 / ODOO-343435
    if (typeof ctx?.getControl === 'function') return ctx.getControl
    const C = globalThis.wijmo?.Control
    return C && typeof C.getControl === 'function' ? (h) => C.getControl(h) : null
}
export function guideTarget_grid(W, ctx = {}) {   // IE 2026 10 08 / ODOO-343435
    let best = null
    const take = (flex, abb) => {   // IE 2026 10 08 / ODOO-343435
        if (!isGridLike(flex)) return
        if (best && best.flex === flex) { if (!best.attr_by_binding && abb) best.attr_by_binding = abb; return }
        if (!best || (flex.rows.length || 0) > (best.flex.rows.length || 0)) best = { flex, attr_by_binding: abb || null }
    }
    const reg = W?.attrs_vueObj   // IE 2026 10 08 / ODOO-343435
    if (isObj(reg)) for (const k in reg) { const v = reg[k]; if (v && !v._unmounted && v.flex && v.attr) take(v.flex, v.attr_by_binding) }
    const el = guideTarget_widgetEl(W)
    const gc = controlGetter(ctx)
    if (gc && el && el.querySelectorAll) {
        for (const h of el.querySelectorAll('.wj-flexgrid')) { let f = null; try { f = gc(h) } catch (e) { f = null } take(f, null) }   // IE 2026 10 08 / ODOO-343435
    }
    return best
}

// IE 2026 10 08 / ODOO-343435: ключи строки для сравнения с row_key / row_hint — скалярные поля dataItem (id; у DL2 object / measure_type / subject_type …; ссылка {value, valueStr} — оба
// значения), условия-равенства строки раскладки _DLRow.where (поле = значение: ключ объекта, меры, типа субъекта) и ключ строки раскладки _DLRow.row_id. Служебные поля (_fe, _DLRow) не берутся
const EQ_CONDITIONS = new Set(['=', '==', 'in'])   // IE 2026 10 08 / ODOO-343435
export function guideTarget_rowKeys(dataItem) {   // IE 2026 10 08 / ODOO-343435
    const out = []
    if (!isObj(dataItem)) return out
    const add = (v) => { if (v === undefined || v === null || v === '' || typeof v === 'object') return; out.push(String(v)) }
    for (const k of Object.keys(dataItem)) {
        if (k.startsWith('_')) continue
        const v = dataItem[k]
        if (isObj(v) && !Array.isArray(v) && ('value' in v || 'valueStr' in v)) { add(v.value); add(v.valueStr) } else add(v)
    }
    const dl = dataItem._DLRow
    if (isObj(dl)) {
        add(dl.row_id)
        for (const w of (Array.isArray(dl.where) ? dl.where : [])) {
            const rv = isObj(w) ? w.rightValue : null
            if (!isObj(rv) || !EQ_CONDITIONS.has(str(w.condition))) continue
            add(rv.value); add(rv.valueStr)
        }
    }
    return out
}
// IE 2026 10 08 / ODOO-343435: колонки «ключей» строки для сравнения по ВИДИМОМУ тексту — видимые и закреплённые слева (frozenColumns) либо с подписями dataMap (id → название: у DL2 в строке
// объекта лежит uuid, на экране «ITEM-003»); таких нет — первая видимая. Индексы колонок
export function guideTarget_keyCols(flex) {   // IE 2026 10 08 / ODOO-343435
    const cols = flex && flex.columns ? [...flex.columns] : []
    const frozen = Number(flex && flex.frozenColumns) || 0
    const out = []
    cols.forEach((c, i) => { if (colVisible(c) && (i < frozen || c.dataMap) && out.length < 12) out.push(i) })
    if (!out.length) { const i = cols.findIndex(colVisible); if (i >= 0) out.push(i) }
    return out
}
const normText = (s) => str(s).replace(/\s+/g, ' ').trim().toLowerCase()   // IE 2026 10 08 / ODOO-343435
// IE 2026 10 08 / ODOO-343435: строка: row_key — id строки данных, ключ строки (guideTarget_rowKeys), видимый текст ключевой ячейки, значение в JSON строки; row_hint — видимый текст ключевой ячейки (равен, затем содержит),
// ключ строки, подстрока JSON строки (JSON — без подчинённых строк flex.childItemsPath: иначе строка-родитель «содержала» бы всё поддерево); -1 — нет.
// flex (необязательно) — грид: по нему читается видимый текст ячеек (flex.getCellData(i, c, true): подписи dataMap, форматирование)
export function guideTarget_findRow(rows, target, flex = null) {   // IE 2026 10 08 / ODOO-343435
    const list = rows ? [...rows] : []
    const key = str(target?.row_key), hint = str(target?.row_hint)
    const childKey = str(flex && flex.childItemsPath)   // IE 2026 10 08 / ODOO-343435
    const cols = flex ? guideTarget_keyCols(flex) : []
    const texts = [], jsons = []
    const textsOf = (n) => texts[n] || (texts[n] = cols.map(c => { try { return normText(flex.getCellData(n, c, true)) } catch (e) { return '' } }))
    const jsonOf = (n) => { if (jsons[n] === undefined) { try { jsons[n] = JSON.stringify(list[n]?.dataItem || {}, childKey ? (k, v) => (k === childKey ? undefined : v) : undefined) } catch (e) { jsons[n] = '' } } return jsons[n] }
    const find = (pred) => { for (let n = 0; n < list.length; n++) { let ok = false; try { ok = !!pred(list[n], n) } catch (e) { ok = false } if (ok) return n } return -1 }   // IE 2026 10 08 / ODOO-343435
    let i = -1
    if (key) {
        i = find(r => str(r?.dataItem?.id) === key)
        if (i < 0) i = find(r => guideTarget_rowKeys(r?.dataItem).includes(key))   // IE 2026 10 08 / ODOO-343435
        if (i < 0 && cols.length) i = find((r, n) => textsOf(n).includes(normText(key)))   // IE 2026 10 08 / ODOO-343435
        if (i < 0) i = find((r, n) => jsonOf(n).includes(JSON.stringify(key)))
    }
    if (i < 0 && hint) {
        if (cols.length) i = find((r, n) => textsOf(n).includes(normText(hint)))   // IE 2026 10 08 / ODOO-343435
        if (i < 0) i = find(r => guideTarget_rowKeys(r?.dataItem).includes(hint))   // IE 2026 10 08 / ODOO-343435
        if (i < 0 && cols.length) i = find((r, n) => textsOf(n).some(t => t && t.includes(normText(hint))))   // IE 2026 10 08 / ODOO-343435
        if (i < 0) i = find((r, n) => jsonOf(n).includes(hint))
    }
    return i
}
// IE 2026 10 08 / ODOO-343435: период отчёта DL2 — колонки '<YYYY-MM-DD>.<мера>' (начало периода + поле меры; в одном периоде их несколько: quantity, offset …). Цель — месяц 'YYYY-MM' или день
// 'YYYY-MM-DD', и если нужна не первая колонка — мера через точку ('2023-08.offset'). Первая ВИДИМАЯ колонка периода (свёрнутые группой шапки — isVisible false, ширина 0); мера названа — именно она
const PERIOD_RE = /^(\d{4}-\d{2}(?:-\d{2})?)(?:[.:/](.+))?$/   // IE 2026 10 08 / ODOO-343435
export function guideTarget_periodCol(columns, col) {   // IE 2026 10 08 / ODOO-343435
    const sp = PERIOD_RE.exec(str(col).trim())
    if (!sp) return -1
    const want = sp[2] ? sp[2].trim().toLowerCase() : ''
    const cols = columns ? [...columns] : []
    return cols.findIndex(c => {
        const m = PERIOD_RE.exec(str(c?.binding))
        if (!m || !colVisible(c) || !m[1].startsWith(sp[1])) return false
        return !want || str(m[2]).trim().toLowerCase() === want
    })
}
// IE 2026 10 08 / ODOO-343435 (+ период отчёта): колонка: binding, 'doc.' + binding, заголовок атрибута колонки (attr_by_binding), заголовок колонки, затем период отчёта (guideTarget_periodCol); без col — -1 (подсвечивается строка / виджет)
export function guideTarget_findCol(columns, target, attrByBinding = null) {
    const cols = columns ? [...columns] : []
    const col = str(target?.col)
    if (!col) return -1
    let i = cols.findIndex(c => str(c?.binding) === col)
    if (i < 0) i = cols.findIndex(c => str(c?.binding) === 'doc.' + col)
    if (i < 0 && attrByBinding) i = cols.findIndex(c => str(attrByBinding?.[c?.binding]?.title) === col)
    if (i < 0) i = cols.findIndex(c => str(c?.header) === col)
    if (i < 0) i = guideTarget_periodCol(cols, col)   // IE 2026 10 08 / ODOO-343435
    return i
}
// IE 2026 10 08 / ODOO-343435: ячейка со значением. У строки-«шапки» блока (DL2: ключ объекта, values_placement none — ячейки периода слиты, текста в них нет) в колонке пусто, паспорта у такой
// ячейки нет: берётся первая видимая строка того же блока (подчинённые — level больше) с текстом в колонке. Свой текст у строки есть или грид плоский (level нет) — сама строка
export function guideTarget_valueRow(flex, irow, icol) {   // IE 2026 10 08 / ODOO-343435
    const rows = flex && flex.rows
    if (!rows || !(irow >= 0) || !(icol >= 0) || typeof flex.getCellData !== 'function') return irow
    const has = (i) => {
        const r = rows[i]
        if (!r || r.isVisible === false || r.visible === false) return false
        try { return !!str(flex.getCellData(i, icol, true)).trim() } catch (e) { return false }
    }
    if (has(irow)) return irow
    const lvl = rows[irow] && rows[irow].level
    if (typeof lvl !== 'number') return irow
    for (let i = irow + 1; i < rows.length; i++) {
        const l = rows[i] && rows[i].level
        if (typeof l === 'number' && l <= lvl) break
        if (has(i)) return i
    }
    return irow
}
// ячейка цели: ждём грид со строкой (данные виджета грузятся после открытия), прокручиваем к ней; { el, irow, icol } или null
export async function guideTarget_cell(W, target, ctx = {}) {
    const sleep = ctx.sleep || defaultSleep
    const alive = ctx.alive || (() => true)
    let left = ctx.targetWaitMs ?? 15000
    let grid = null, irow = -1
    while (left >= 0) {
        if (!alive()) return null
        grid = guideTarget_grid(W, ctx)   // IE 2026 10 08 / ODOO-343435: ctx — getControl
        irow = grid?.flex ? guideTarget_findRow(grid.flex.rows, target, grid.flex) : -1   // IE 2026 10 08 / ODOO-343435
        if (irow >= 0) break
        left -= 400
        if (left >= 0) await sleep(400)
    }
    if (!grid || irow < 0) return null
    const flex = grid.flex
    const icol = guideTarget_findCol(flex.columns, target, grid.attr_by_binding)
    const vrow = icol >= 0 ? guideTarget_valueRow(flex, irow, icol) : irow   // IE 2026 10 08 / ODOO-343435
    const ci = icol >= 0 ? icol : Math.max(0, [...(flex.columns || [])].findIndex(c => colVisible(c)))   // IE 2026 10 08 / ODOO-343435
    let el = null
    for (let k = 0; k < 6 && !el; k++) {
        try { flex.scrollIntoView(vrow, ci) } catch (e) { /* no-op */ }   // IE 2026 10 08 / ODOO-343435
        await sleep(k ? 250 : 50)
        try { el = flex.cells.getCellElement(vrow, ci) } catch (e) { el = null }   // IE 2026 10 08 / ODOO-343435
    }
    if (!el) return null
    // без колонки — подсвечивается строка: элемент строки грида, если есть
    if (icol < 0 && el.parentElement && el.parentElement.classList && el.parentElement.classList.contains('wj-row')) el = el.parentElement
    return { el, irow: vrow, icol, grid }   // IE 2026 10 08 / ODOO-343435
}

// ======================================================================= вкладка виджета
// открыть вкладку формы виджета по имени (name / title): панель вкладок, зарегистрированная в WIDGET.attrs_vueObj (как store.widget_activeTab читает её)
export function guideTarget_openTab(W, tab) {
    const want = str(tab)
    if (!want || !isObj(W?.attrs_vueObj)) return false
    for (const key in W.attrs_vueObj) {
        const v = W.attrs_vueObj[key]
        if (!v || v._unmounted || !v.tabPanel) continue
        const tabs = (('tabAttrs' in v) ? v.tabAttrs : null) || []
        const i = tabs.findIndex(x => x && (str(x.name) === want || str(x.title) === want))
        if (i < 0) continue
        try { v.tabPanel.selectedIndex = i } catch (e) { return false }
        return true
    }
    return false
}

// ======================================================================= чипс шапки
export function guideTarget_chipEl(doc, target) {
    const b = str(target?.binding)
    if (!doc || !b || typeof doc.querySelectorAll !== 'function') return null
    try {
        const byAttr = doc.querySelector(`[data-binding="${b.replace(/"/g, '')}"]`)
        if (byAttr) return byAttr
    } catch (e) { /* селектор с неожиданными символами */ }
    for (const el of doc.querySelectorAll('.chip, .p-chip, [class*="chip"]')) {
        if (str(el.textContent).toLowerCase().includes(b.toLowerCase())) return el
    }
    return null
}

// demo-webscm 2026 11 02 / ODOO-350612 (замечание Андрея: шаги навигатора без подсветки): элементы, которые объясняются по Alt функцией подсказки
// (AttrGrid.uiHelp_cellSub и т.п.), а не v-uiHelp, — без data-help в DOM; для них ключ реестра → селектор. Ключ с data-help всегда в приоритете.
// demo-webscm 2026 11 02 / ODOO-350612 (e2e всех 38 тем на devap -111/-126: 11 тем без подсветки): значение — селектор или СПИСОК селекторов по порядку
// (первый видимый элемент из всех; видимого нет — первый найденный). Запасные цели — когда своего элемента на экране нет: кнопка вынесена в другую
// форму (меню пользователя и меню страницы — формы MenuPanel / WorkspaceMenuForm, PR p214), появляется только по состоянию (стрелка ячейки — при наведении,
// «⋯» панели — когда команды не влезли, история — у редактируемой таблицы, кнопки фильтров — в открытом списке чипсов) — тогда обводится то, с чего начинают
export const UI_HELP_SELECTORS = {
    'grid.cellFormArrow': ['.cell-dropdown-toggle', '[data-help="grid.cellFormTagBtn"]'],   // стрелка формы ячейки (AttrGrid.uiHelp_cellSub; видна при наведении) → кнопка 🏷
    'grid.collapseToggle': '.wj-elem-collapse',       // треугольник свёртки дерева / группы (wijmo)
    'topbar.user.fallback': ['[data-help="menuPanel.btn.user"]', '.user-menu-btn'],   // прежнее wj-menu #menu_1 (v-else) — при форме меню пользователя его нет
    'menuPanel.btn.page': ['[data-help="menuPanel.btn.workspace"]', '.page-menu-btn:not(.pages-menu-btn)'],   // меню страницы — вкладка «Меню» формы меню рабочей области (fe.ux.workspaceMenuTabs)
    'chips.input': '[data-help="chips.bar.input"]',   // поле поиска строки чипсов
    'grid.commandPanel.overflow': '.commandPanel-menu',   // «⋯» есть, только когда команды не влезли — иначе сама панель команд таблицы
    'grid.cmd.history': '[data-help="grid.cmd.readOnlyOff"]',   // история — у редактируемой таблицы; у read-only — кнопка «редактировать»
    'chips.cmd.btn.filters-save': '[data-help="chips.dropdown-button"]',   // кнопка — в открытом списке чипсов; закрыт — кнопка, которая его открывает
    'chips.cmd.btn.page-save': '[data-help="chips.dropdown-button"]',
    // demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «Куда-то отправляет в меню пользователя. Но не понятно куда»): пункты ОТКРЫТОГО меню пользователя
    // (MenuPanel data-cmd — команда / английский ключ пункта); меню закрыто — пунктов в DOM нет, тема сначала просит открыть меню (wait_for dom)
    'userMenu.theme': '.menu-panel [data-cmd="toggleDarkMode"]',
    'userMenu.tooltips': '.menu-panel [data-cmd="showTooltip"]',
    'userMenu.navigatorAtStart': '.menu-panel [data-cmd="navigatorAtStart"]',
    'userMenu.language': '.menu-panel [data-cmd="Language"]',
    'userMenu.colorScheme': '.menu-panel [data-cmd="Color scheme"]',
    'userMenu.logout': '.menu-panel [data-cmd="onLogOut__Click"]',
}

// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «Иногда при нажатии на процессную модель не происходит выбор процессной модели, хотя подсказка сама
// закрывается»): ключ topbar.pm (и topbar.db) первым в DOM стоит на ИКОНКЕ шапки (<i class="logo_pi …">, AppTopbar) — без обработчика нажатия; кнопка
// модели — форма меню (MenuPanel, data-help «menuPanel.btn.pm», класс .pm-menu-btn) или прежнее wj-menu #menu_pm, кнопка базы — .db-chip. Цель шага была
// иконкой: нажатие по обведённому снимало подсказку, а меню не открывалось. Для таких ключей сначала ищется видимый ЭЛЕМЕНТ УПРАВЛЕНИЯ, затем — как было
export const UI_HELP_CONTROLS = {
    'topbar.pm': '.pm-menu-btn, #menu_pm',
    'topbar.db': '.db-chip',
}

// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «Страницы рабочей области их много нужно выделить было все в столбике»): ключи-ГРУППЫ — цель
// не один элемент, а столбик однородных элементов (одна обводка и одна выноска на весь столбик). Ключ → селектор членов группы. topbar.rail — рейка
// страниц целиком; topbar.rail.page — прежний ключ контента (шаг «Сторінки цієї робочої області»), как цель тура означает ту же рейку (одна кнопка
// страницы показывается маршрутом: guideRoute_el, a[data-page-index]). Обёртки рейки (.pages-rail-clip / -scroller) целью быть не могут: при плавной
// прокрутке они fixed на весь экран, без неё — display: contents (прямоугольника нет)
const RAIL_ROWS = '.workspace-pages .left-area-button-tab'
export const UI_HELP_GROUPS = {
    'topbar.rail': RAIL_ROWS,
    'topbar.rail.page': RAIL_ROWS,
}
// окно рейки при плавной прокрутке: clip-path обёртки inset(<top>px 0 calc(100% - <bottom>px) 0) (Page.vue railClipStyle) — строки за окном не в счёт
function clipWindow(el) {
    const c = el && typeof el.closest === 'function' ? el.closest('.pages-rail-clip') : null
    const m = c && /inset\(\s*(-?[\d.]+)px\s+\S+\s+calc\(100%\s*-\s*(-?[\d.]+)px\)/.exec(str(c.style && c.style.clipPath))
    return m ? { top: Number(m[1]), bottom: Number(m[2]) } : null
}
// ODOO-350612: «элемент» группы для guideTarget_mark: прямоугольник — объединение ВИДИМЫХ членов (в окне рейки и окна браузера), члены перечитываются
// при каждом вызове (строки рейки перестраиваются, keep-alive меняет страницы); contains — нажатие по любому члену (закрыть выноску); видимых нет — 0×0
export function guideTarget_groupEl(doc, sel, win = globalThis.window) {
    const members = () => { try { return [...doc.querySelectorAll(sel)] } catch (e) { return [] } }
    const rects = () => {
        const vh = win?.innerHeight || Infinity, vw = win?.innerWidth || Infinity
        const out = []
        for (const el of members()) {
            if (!el || el.isConnected === false || typeof el.getBoundingClientRect !== 'function') continue
            const r = el.getBoundingClientRect()
            if (!(r.width > 0 && r.height > 0)) continue
            const w = clipWindow(el)
            const top = Math.max(r.top, w ? w.top : -Infinity, 0), bottom = Math.min(r.bottom, w ? w.bottom : Infinity, vh)
            const left = Math.max(r.left, 0), right = Math.min(r.right, vw)
            if (bottom - top > 1 && right - left > 1) out.push({ left, top, right, bottom })
        }
        return out
    }
    return {
        nodeType: 1, guideGroup: sel,
        get isConnected() { return members().some(el => el && el.isConnected !== false) },
        getBoundingClientRect() {
            const rs = rects()
            if (!rs.length) return { left: 0, top: 0, right: 0, bottom: 0, width: 0, height: 0, x: 0, y: 0 }
            const left = Math.min(...rs.map(r => r.left)), top = Math.min(...rs.map(r => r.top))
            const right = Math.max(...rs.map(r => r.right)), bottom = Math.max(...rs.map(r => r.bottom))
            return { left, top, right, bottom, width: right - left, height: bottom - top, x: left, y: top }
        },
        contains(t) { return !!t && members().some(el => el === t || (typeof el.contains === 'function' && el.contains(t))) },
        visibleCount() { return rects().length },
    }
}

// demo-webscm 2026 11 02 / ODOO-350612: цель kind 'ui' — первый ВИДИМЫЙ элемент с data-help = target.help (несколько одинаковых ключей — у рейла и панели «⋮»);
// ключ-группа (UI_HELP_GROUPS) — столбик целиком (guideTarget_groupEl), видимых членов нет — null
export function guideTarget_uiEl(doc, target) {
    const key = str(target?.help)
    if (!key || !doc?.querySelectorAll) return null
    if (UI_HELP_GROUPS[key]) {
        const g = guideTarget_groupEl(doc, UI_HELP_GROUPS[key], doc.defaultView || globalThis.window)
        return g.visibleCount() ? g : null
    }
    if (UI_HELP_CONTROLS[key]) {
        try { for (const el of doc.querySelectorAll(UI_HELP_CONTROLS[key])) if (el.offsetWidth > 0 || el.offsetHeight > 0) return el } catch (e) { /* селектор */ }
    }
    let first = null
    try {
        const sels = [`[data-help="${key.replace(/"/g, '\\"')}"]`].concat(UI_HELP_SELECTORS[key] || [])   // ODOO-350612: строка или список селекторов
        for (const sel of sels) {
            for (const el of doc.querySelectorAll(sel)) {
                if (!first) first = el
                if (el.offsetWidth > 0 || el.offsetHeight > 0) return el
            }
        }
    } catch (e) { return null }
    return first
}

// ======================================================================= разрешить цель → элемент
// { el, kind, W, fallback }: fallback — цель уже (ячейка не нашлась → виджет); null — ничего нет на экране
export async function guideTarget_resolve(store, target, ctx = {}) {
    if (!isObj(target)) return null
    const sleep = ctx.sleep || defaultSleep
    const alive = ctx.alive || (() => true)
    const doc = ctx.doc || globalThis.document
    const kind = str(target.kind || (target.row_key || target.row_hint ? 'cell' : 'widget'))
    if (kind === 'chip') {
        const el = guideTarget_chipEl(doc, target)
        return el ? { el, kind, W: null, fallback: false } : null
    }
    if (kind === 'ui') {   // demo-webscm 2026 11 02 / ODOO-350612 (навигатор): элемент каркаса по ключу реестра uiHelp — v-uiHelp ставит data-help="<ключ>" (шапка, рейка, кнопки); виджет не нужен
        const el = guideTarget_uiEl(doc, target)
        return el ? { el, kind, W: null, fallback: false } : null
    }
    let W = null
    let left = ctx.widgetWaitMs ?? 10000
    while (left >= 0) {
        if (!alive()) return null
        W = guideTarget_findWidget(store, target)
        if (W && guideTarget_widgetEl(W)) break
        left -= 300
        if (left >= 0) await sleep(300)
    }
    if (!W) return null
    if (kind === 'cell') {
        const c = await guideTarget_cell(W, target, ctx)
        if (c) return { el: c.el, kind, W, fallback: false, irow: c.irow, icol: c.icol, flex: c.grid?.flex } // IE 2026 10 13 / ODOO-343435
    }
    const el = guideTarget_widgetEl(W)
    return el ? { el, kind: 'widget', W, fallback: kind !== 'widget' } : null
}

// IE 2026 10 13 / ODOO-343435: с 09a9ec9b3 (ODOO-343342) клик по ячейке только выделяет её, паспорт (форма ячейки) открывают 🏷 / F4 / контекстное меню — шаг тура открывает его тем же путём (AttrGrid.cellForm_toggle)
// AttrGrid грида цели: компонент из реестра W.attrs_vueObj с тем же flex, что у найденной ячейки; нет — W.vueObj
function passportGrid(res) {   // IE 2026 10 13 / ODOO-343435
    const W = res?.W   // IE 2026 10 13 / ODOO-343435
    const reg = W?.attrs_vueObj   // IE 2026 10 13 / ODOO-343435
    if (res?.flex && isObj(reg)) {   // IE 2026 10 13 / ODOO-343435
        for (const k in reg) { const v = reg[k]; if (v && !v._unmounted && v.flex === res.flex && typeof v.cellForm_toggle === 'function') return v }   // IE 2026 10 13 / ODOO-343435
    }   // IE 2026 10 13 / ODOO-343435
    return W?.vueObj   // IE 2026 10 13 / ODOO-343435
}   // IE 2026 10 13 / ODOO-343435
// irow / icol из guideTarget_cell — индексы строки / колонки грида (flex.cells.getCellElement(irow, icol)), те же, что ждёт cellForm_toggle(row, col)
export function guideTarget_openPassport(res) {   // IE 2026 10 13 / ODOO-343435
    const v = passportGrid(res)   // IE 2026 10 13 / ODOO-343435
    if (!v || typeof v.cellForm_toggle !== 'function') return false   // IE 2026 10 13 / ODOO-343435
    if (!(res.irow >= 0) || !(res.icol >= 0)) return false   // IE 2026 10 13 / ODOO-343435: колонка не найдена — подсвечена строка, паспорта нет
    if (typeof v.cellFormTag_here === 'function' && v.cellFormTag_here()) return true   // IE 2026 10 13 / ODOO-343435
    try { return v.cellForm_toggle(res.irow, res.icol) !== false } catch (e) { return false }   // IE 2026 10 13 / ODOO-343435
}   // IE 2026 10 13 / ODOO-343435
// форма ячейки открывается только 🏷 / F4 / контекстным меню (клик по ячейке её лишь выделяет)
export function guideTarget_onlyByButton(res) {   // IE 2026 10 13 / ODOO-343435
    const v = passportGrid(res)   // IE 2026 10 13 / ODOO-343435
    try { return !!(v && typeof v.cellForm_onlyByButton === 'function' && v.cellForm_onlyByButton()) } catch (e) { return false }   // IE 2026 10 13 / ODOO-343435
}   // IE 2026 10 13 / ODOO-343435
// кнопка 🏷 формы ячейки в командной строке грида виджета; нет — null
export function guideTarget_tagBtn(W) {   // IE 2026 10 13 / ODOO-343435
    const el = guideTarget_widgetEl(W)   // IE 2026 10 13 / ODOO-343435
    try { return (el && el.querySelector && el.querySelector('.cellform-tag-btn')) || null } catch (e) { return null }   // IE 2026 10 13 / ODOO-343435
}   // IE 2026 10 13 / ODOO-343435

// синтетический клик по элементу (как шаг click_cell клиентских тестов): открывает штатный dropdown ячейки → паспорт (метод чтения cell_passport)
export function guideTarget_click(el) {
    if (!el || typeof el.dispatchEvent !== 'function' || typeof MouseEvent === 'undefined') return false
    const r = el.getBoundingClientRect()
    for (const type of ['mousedown', 'mouseup', 'click']) {
        el.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, clientX: r.x + r.width / 2, clientY: r.y + r.height / 2 }))
    }
    return true
}

// ======================================================================= подсветка (рамка + подсказка)
const marks = new Set()
// ODOO-350612: показанные подсказки (id → цель и opts) — для guideTarget_reshow; снятие их не забывает
const MARKS_KEEP = 100
const shown = new Map()
let markSeq = 0
function remember(id, el, opts) {
    shown.set(id, { el, opts })
    while (shown.size > MARKS_KEEP) shown.delete(shown.keys().next().value)
}
// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «с введением навигатора интерфейс стал притормаживать»): было — у КАЖДОЙ подсказки свой setInterval
// 400 мс с полной раскладкой (прямоугольники всех целей, обход текста шапки TreeWalker + Range.getClientRects, док, до 4 проходов выбора места) и запись
// стилей вперемешку с чтением — принудительная перерисовка каждые 400 мс на каждую подсказку, пока они висят (маршрут показа остаётся после показа).
// Стало: ОДИН общий такт на все подсказки; такт читает только прямоугольники целей / дока, окно и тему — ничего не сдвинулось, раскладка не делается
// (полная — раз в LOOP_FULL_EVERY тактов, на случай смены текста шапки / размера выноски); вкладка скрыта — такт пропускается; подсказок нет — такта нет
const LOOP_FULL_EVERY = 10
const loop = { timer: null, n: 0, key: '', ticks: 0, placed: 0, skipped: 0, frame: false }
// ODOO-350612 (e2e -126: 3 подсказки во время перестройки страницы): такт читает прямоугольники в кадре браузера (requestAnimationFrame) — чтение после
// записей страницы не заставляет делать ЛИШНИЙ пересчёт стилей / раскладки посреди её работы (кадр всё равно их сделает); один кадр на такт
function loopKick() {
    const raf = globalThis.requestAnimationFrame
    if (typeof raf !== 'function') { loopTick(); return }
    if (loop.frame) return
    loop.frame = true
    raf(() => { loop.frame = false; loopTick() })
}
function loopStart(every) {
    if (loop.timer) return
    loop.n = 0; loop.key = ''; loop.frame = false
    loop.timer = setInterval(loopKick, every)
}
function loopStop() { if (loop.timer) { clearInterval(loop.timer); loop.timer = null } loop.key = '' }
const rectKey = (r) => r ? [r.left, r.top, r.width, r.height].map(v => Math.round(Number(v) || 0)).join(',') : '-'
function loopTick() {
    if (!marks.size) { loopStop(); return }
    const list = [...marks]
    const doc = list[0].doc, win = list[0].win
    if (doc && doc.hidden === true) return
    loop.ticks++; loop.n++
    let key = ''
    try {
        const dock = guideTarget_dockRects(doc, null)[0] || null
        key = [win?.innerWidth, win?.innerHeight, guideTarget_isDark(doc) ? 1 : 0, rectKey(dock),
            ...list.map(h => h.id + ':' + (h.el.isConnected ? rectKey(h.el.getBoundingClientRect()) : 'x'))].join('|')
    } catch (e) { key = '' }
    if (key && key === loop.key && loop.n % LOOP_FULL_EVERY !== 0) { loop.skipped++; return }
    loop.key = key
    for (const h of list) { try { h.place(); loop.placed++ } catch (e) { /* подсветка уже снята */ } }
}
// ODOO-350612: нажатие пользователя по цели закрывает её подсказку — общий слушатель документа (4 слушателя захвата на документ + keydown Escape, а не на каждую подсказку;
// подсказок нет — слушателей нет). Закрытие — ПОСЛЕ того, как нажатие дошло до цели: pointerdown по цели только «взводит» подсказку, снимается она по
// pointerup / click через setTimeout (мышь — 0: click идёт в той же задаче, что и mouseup; касание / перо — TOUCH_CLOSE_MS: click у касания приходит
// отдельной задачей после жеста). Было: снятие прямо в pointerdown — удаление узлов и переприсвоение store.guideSession (перерисовка дока / полосы,
// сдвиг раскладки) шли МЕЖДУ mousedown и click, и нажатие по цели (выбор процессной модели) терялось, хотя подсказка закрывалась
const TOUCH_CLOSE_MS = 400
const hub = new Map()   // document → { n, on: [[type, fn]] }
function hubOn(doc) {
    const cur = hub.get(doc)
    if (cur) { cur.n++; return }
    const each = (fn) => { for (const h of [...marks]) if (h.doc === doc && h.closeOnTarget) fn(h) }
    const trusted = (ev) => !!ev && ev.isTrusted !== false   // программный el.click() тура (guideTarget_click) подсказку не снимает
    const on = [
        ['pointerdown', (ev) => { if (trusted(ev)) each(h => { h.armed = h.hit(ev.target) }) }],
        ['pointerup', (ev) => { if (!trusted(ev)) return; const ms = ev.pointerType && ev.pointerType !== 'mouse' ? TOUCH_CLOSE_MS : 0; each(h => { if (h.armed) { h.armed = false; h.closeSoon(ms) } }) }],
        ['pointercancel', () => each(h => { h.armed = false })],   // касание ушло в прокрутку — не нажатие
        ['click', (ev) => { if (trusted(ev)) each(h => { if (h.armed || h.closeT || h.hit(ev.target)) { h.armed = false; h.closeSoon(0) } }) }],   // + клавиатура: Enter / Space по цели в фокусе
        // demo-webscm 2026 11 02 / ODOO-350612 (devap -136: Escape не закрывал выноску темы 8 — обработчика не было никогда): Escape снимает ПОСЛЕДНЮЮ видимую
        // выноску с × (как ×: close → onClose приглушает строку шага); снята — Escape дальше не идёт (иначе тем же нажатием закрылся бы активный виджет);
        // закрывать нечего — нажатие не трогаем
        // demo-webscm 2026 11 03 / ODOO-350612 (devap -139, тема 8: Escape снял выноску И закрыл WIDGET13, 9 → 8 виджетов): слушатель был на document в захвате —
        // там же, где App.handleKeydown (document, capture, зарегистрирован раньше при монтировании App) → тот шёл ПЕРВЫМ и закрывал активный виджет, а
        // stopPropagation соседей по тому же узлу не останавливает. Теперь Escape — на window в захвате (раньше любого слушателя document) и, когда выноска
        // снята, preventDefault + stopImmediatePropagation: до document событие не доходит вовсе. Тот же приём — AttrBubbleChart.picker_onEscape (IE 2026 09 16)
        ['keydown', (ev) => {
            if (!trusted(ev) || (ev.key !== 'Escape' && ev.key !== 'Esc')) return
            let last = null
            for (const h of marks) if (h.doc === doc && h.closable && h.tip && h.tip.isConnected !== false && h.tip.style?.display !== 'none') last = h
            if (!last) return
            last.close('esc')
            if (typeof ev.preventDefault === 'function') ev.preventDefault()
            if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation()
            else if (typeof ev.stopPropagation === 'function') ev.stopPropagation()
        }, 'win'],
    ]
    const win = doc.defaultView && typeof doc.defaultView.addEventListener === 'function' ? doc.defaultView : doc   // окна нет (заглушка) — документ
    for (const l of on) { l[3] = l[2] === 'win' ? win : doc; l[3].addEventListener(l[0], l[1], true) }
    hub.set(doc, { n: 1, on })
}
function hubOff(doc) {
    const cur = hub.get(doc)
    if (!cur || --cur.n > 0) return
    hub.delete(doc)
    for (const [type, fn, , tgt] of cur.on) { try { (tgt || doc).removeEventListener(type, fn, true) } catch (e) { /* no-op */ } }
}
// ODOO-350612: что висит в простое — общий такт (0 / 1), слушатели документа, подсказки; ticks / placed / skipped — счётчики такта (замер в юните)
export function guideTarget_idleStats() {
    let listeners = 0
    for (const v of hub.values()) listeners += v.on.length
    return { timers: loop.timer ? 1 : 0, listeners, marks: marks.size, ticks: loop.ticks, placed: loop.placed, skipped: loop.skipped }
}
const STYLE_ID = 'guide-tour-mark-style'
// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «Выделенная зона… не очевидна. Нужно её подсветить, обвести радиусом. На дизайне была тоже слева полоса
// цвета обводки» — out/navigator/prototype_v2.html .hl / .tip): цель — скруглённая оранжевая обводка 3px + мягкое гало и тонкое тёмное кольцо (видно и на светлом,
// и на тёмном фоне, и поверх цветной шапки); рамка/подсказка fixed поверх страницы — раскладку не сдвигают. Цвет обводки — --guide-hl.
// ODOO-350612 (слово владельца: «на маленьких кнопках цифра все закрывает. Ее нужно ставить рядом или рисовать выноску с контрастным фоном (см. пример с синим
// фоном)… Два раза номер - перебор»): подсказка — выноска --guide-callout (синий #0a6fb8, белый текст 5.3:1; вне инвертированного .dark-theme — та же в обеих
// темах) рядом с целью, с хвостом к ней (.guide-tour-tail, guideTarget_tailPts); номер — один раз, внутри выноски («1. …»), кружка на цели нет
// demo-webscm 2026 11 03 / ODOO-350612 (dm: выноска «Мова» темы 4 / 35 спряталась под открытым меню пользователя): обводка / хвост / выноска — над
// меню и выпадашками (MenuPanel .menu-panel z-index 10001, шапка 10000, свободные виджеты 1300…1400); было 1002…1004 — под ними
const CSS = `
:root { --guide-hl: #ff9f1a; --guide-hl-soft: rgba(255, 159, 26, .32); --guide-callout: #0a6fb8; }
.guide-tour-mark { position: fixed; z-index: 10002; pointer-events: none; box-sizing: border-box; border-radius: 10px;
  border: 3px solid var(--guide-hl); box-shadow: 0 0 0 1px rgba(0, 0, 0, .28), 0 0 0 6px var(--guide-hl-soft), 0 0 0 7px rgba(0, 0, 0, .12);
  transition: top .15s, left .15s, width .15s, height .15s; }
.guide-tour-mark.gtm-pulse { animation: gtm-pulse 1.6s ease-out 3; }
@keyframes gtm-pulse { 0% { box-shadow: 0 0 0 1px rgba(0, 0, 0, .28), 0 0 0 6px var(--guide-hl-soft), 0 0 0 7px rgba(0, 0, 0, .12), 0 0 0 0 rgba(255, 159, 26, .6); }
  100% { box-shadow: 0 0 0 1px rgba(0, 0, 0, .28), 0 0 0 6px var(--guide-hl-soft), 0 0 0 7px rgba(0, 0, 0, .12), 0 0 0 18px rgba(255, 159, 26, 0); } }
.guide-tour-tip { position: fixed; z-index: 10004; max-width: min(340px, calc(100vw - 24px)); box-sizing: border-box; padding: 8px 13px; border-radius: 8px;
  background: var(--guide-callout); color: #fff; border: 1px solid rgba(0, 0, 0, .18);
  box-shadow: 0 6px 18px rgba(0, 0, 0, .28); font-size: 15px; font-weight: 500; line-height: 1.4; pointer-events: auto; }
.guide-tour-tip img { display: block; max-width: 100%; margin-top: 6px; border-radius: 4px; }
.guide-tour-tip .guide-tour-tip-n { font-weight: 700; margin-right: 5px; }
.guide-tour-tip.gt-closable { padding-right: 32px; }
.guide-tour-tip-x { position: absolute; top: 4px; right: 4px; width: 22px; height: 22px; padding: 0; border: 0; border-radius: 4px; background: transparent; color: #fff;
  font: 700 17px/22px system-ui, sans-serif; text-align: center; cursor: pointer; opacity: .85; }
.guide-tour-tip-x:hover { opacity: 1; background: rgba(255, 255, 255, .2); }
.guide-tour-tip-x:focus-visible { opacity: 1; outline: 2px solid #fff; outline-offset: 1px; }
.guide-tour-tail { position: fixed; z-index: 10003; background: var(--guide-callout); pointer-events: none; }
.guide-tour-mark.gt-dark { box-shadow: 0 0 0 1px rgba(255, 255, 255, .28), 0 0 0 6px var(--guide-hl-soft), 0 0 0 7px rgba(255, 255, 255, .12); }
.guide-tour-tip.gt-dark { border-color: rgba(255, 255, 255, .45); box-shadow: 0 6px 18px rgba(0, 0, 0, .6); }
@media (max-width: 760px) { .guide-tour-tip { left: 8px !important; right: 8px; top: auto !important; bottom: 120px; max-width: none; } .guide-tour-tail { display: none !important; } }
`
function ensureStyle(doc) {
    if (!doc || !doc.head || doc.getElementById?.(STYLE_ID)) return
    const s = doc.createElement('style')
    s.id = STYLE_ID
    s.textContent = CSS
    doc.head.appendChild(s)
}
// место подсказки у прямоугольника цели: справа / слева / сверху / снизу, в пределах окна (vw × vh); tip — {w, h}
// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «плашка ориентирована только на одну кнопку, а выделено несколько кнопок»): avoid — чужие
// прямоугольники (соседние цели с их обводкой, прежние выноски): выноска не ложится ни на один. Перебор: отступ от цели (gap, +20, +50, +100) → сдвиг вдоль
// стороны (0, ±12, ±24 … — до диагонали за угол цели) → сторона по порядку; первая свободная (и хвост не пересекает выноски avoidTail); near > 0 — только
// вплотную: отступ gap и до цели не дальше near px (сдвиг вдоль стороны не уводит выноску далеко). Хвост (guideTarget_tailPts) дотягивается до цели из любого места.
// Свободной нет — первая сторона, что влезает, без сдвига (дальше tipAvoid)
export function guideTarget_tipPos(rect, tip, placement = 'right', vw = 1280, vh = 800, gap = 10, avoid = [], avoidTail = [], near = 0) {
    const w = tip?.w || 280, h = tip?.h || 60
    const order = { right: ['right', 'bottom', 'left', 'top'], left: ['left', 'bottom', 'right', 'top'], top: ['top', 'bottom', 'right', 'left'],
        bottom: ['bottom', 'top', 'right', 'left'] }[placement] || ['right', 'bottom', 'left', 'top']
    const clampX = (x) => Math.max(8, Math.min(vw - w - 8, x)), clampY = (y) => Math.max(8, Math.min(vh - h - 8, y))
    const at = (p, d, s) => {
        if (p === 'right' && rect.right + d + w <= vw - 8) return { left: rect.right + d, top: clampY(rect.top + s), placement: p }
        if (p === 'left' && rect.left - d - w >= 8) return { left: rect.left - d - w, top: clampY(rect.top + s), placement: p }
        if (p === 'bottom' && rect.bottom + d + h <= vh - 8) return { left: clampX(rect.left + s), top: rect.bottom + d, placement: p }
        if (p === 'top' && rect.top - d - h >= 8) return { left: clampX(rect.left + s), top: rect.top - d - h, placement: p }
        return null
    }
    const cross = (a, o) => a.left < o.right && a.right > o.left && a.top < o.bottom && a.bottom > o.top
    // avoidTail — прежние выноски: хвост новой не должен их пересекать (иначе кажется, что хвост — от чужой выноски)
    const tailHits = (pos) => { const t = guideTarget_tailPts(rect, { ...pos, w, h }); return !!t && avoidTail.some(o => cross({ left: t.left, top: t.top, right: t.left + t.width, bottom: t.top + t.height }, o)) }
    const hits = (pos) => avoid.some(o => cross({ left: pos.left, top: pos.top, right: pos.left + w, bottom: pos.top + h }, o)) || (avoidTail.length > 0 && tailHits(pos))
    const first = order.map(p => at(p, gap, 0)).find(Boolean) || null
    if (!avoid.length) return first || { left: clampX(rect.left), top: clampY(rect.bottom + gap), placement: 'inside' }
    const reach = Math.max(w, h) + 40, step = 12
    const sep = (pos) => Math.hypot(Math.max(0, pos.left - rect.right, rect.left - pos.left - w), Math.max(0, pos.top - rect.bottom, rect.top - pos.top - h))
    for (const d of (near ? [gap] : [gap, gap + 20, gap + 50, gap + 100])) {
        for (let k = 0; k * step <= reach; k++) {
            for (const s of (k ? [k * step, -k * step] : [0])) {
                for (const p of order) {
                    const span = (p === 'right' || p === 'left') ? h : w
                    if (s < -span - 20) continue   // дальше диагонали за угол цели — не «рядом»
                    const pos = at(p, d, s)
                    if (pos && !hits(pos) && (!near || sep(pos) <= near)) return pos
                }
            }
        }
    }
    if (first) return { ...first, busy: true }   // busy — свободного места не нашлось (вызывающий может повторить с меньшими полями)
    return { left: clampX(rect.left), top: clampY(rect.bottom + gap), placement: 'inside', busy: true }
}
// demo-webscm 2026 11 02 / ODOO-350612 (пример владельца — синяя выноска с косым хвостом к кнопке): хвост выноски — треугольник от её стороны, обращённой к цели
// (ось с бо́льшим зазором; по диагонали — клин из ближнего угла выноски к углу обводки; основание base px, у центра цели в пределах стороны, на inset px внутри выноски — без шва), вершина — на краю обводки цели (pad: зазор 4
// + рамка 3), ближайшая к основанию точка: иконку цели хвост не закрывает. target — прямоугольник цели, tip — {left, top, w, h}; null — выноска легла на обводку.
// Ответ: {left, top, width, height} (fixed-блок хвоста), clip — clip-path polygon в его координатах, pts — три точки в координатах окна
export function guideTarget_tailPts(target, tip, pad = 7, base = 16, inset = 2) {
    const T = { left: target.left - pad, top: target.top - pad, right: target.right + pad, bottom: target.bottom + pad }
    const B = { left: tip.left, top: tip.top, right: tip.left + (tip.w || 0), bottom: tip.top + (tip.h || 0) }
    const dx = B.left >= T.right ? B.left - T.right : T.left >= B.right ? T.left - B.right : -1
    const dy = B.top >= T.bottom ? B.top - T.bottom : T.top >= B.bottom ? T.top - B.bottom : -1
    if (dx <= 0 && dy <= 0) return null
    const half = base / 2
    const clamp = (v, a, b) => (a > b ? (a + b) / 2 : Math.max(a, Math.min(b, v)))
    const cx = (target.left + target.right) / 2, cy = (target.top + target.bottom) / 2
    let pts
    if (dx > 0 && dy > 0) {   // выноска по диагонали от цели — хвост клином из её ближнего угла к углу обводки
        const sx = B.left >= T.right ? 1 : -1, sy = B.top >= T.bottom ? 1 : -1
        const x0 = sx > 0 ? B.left : B.right, y0 = sy > 0 ? B.top : B.bottom
        pts = [[x0 + sx * inset, y0 + sy * (inset + base)], [x0 + sx * (inset + base), y0 + sy * inset], [sx > 0 ? T.right : T.left, sy > 0 ? T.bottom : T.top]]
    } else if (dx >= dy) {
        const toRight = B.left >= T.right   // выноска справа от цели
        const ex = toRight ? B.left + inset : B.right - inset
        const by = clamp(cy, B.top + half + 6, B.bottom - half - 6)
        pts = [[ex, by - half], [ex, by + half], [toRight ? T.right : T.left, clamp(by, target.top, target.bottom)]]
    } else {
        const below = B.top >= T.bottom
        const ey = below ? B.top + inset : B.bottom - inset
        const bx = clamp(cx, B.left + half + 6, B.right - half - 6)
        pts = [[bx - half, ey], [bx + half, ey], [clamp(bx, target.left, target.right), below ? T.bottom : T.top]]
    }
    pts = pts.map(([x, y]) => [Math.round(x), Math.round(y)])
    const xs = pts.map(q => q[0]), ys = pts.map(q => q[1])
    const left = Math.min(...xs), top = Math.min(...ys)
    const width = Math.max(1, Math.max(...xs) - left), height = Math.max(1, Math.max(...ys) - top)
    const clip = 'polygon(' + pts.map(([x, y]) => (x - left) + 'px ' + (y - top) + 'px').join(', ') + ')'
    return { left, top, width, height, clip, pts }
}
// demo-webscm 2026 11 02 / ODOO-350612: несколько подсказок одновременно (маршрут навигатора: стол, страница, цель — все у левого края) — новая не ложится
// на прежние: пересеклась с чужим прямоугольником — уходит под него (top = его bottom + gap), пока не станет свободно; снизу окно кончилось — остаётся, где была
export function guideTarget_tipAvoid(pos, tip, others = [], vh = 800, gap = 6) {
    const w = tip?.w || 280, h = tip?.h || 60
    let top = pos.top
    const hit = (o) => pos.left < o.right && pos.left + w > o.left && top < o.bottom && top + h > o.top
    for (let i = 0; i < 12; i++) {
        const o = others.find(hit)
        if (!o) break
        const next = o.bottom + gap
        if (next + h > vh - 8) return pos
        top = next
    }
    return { ...pos, top }
}
// demo-webscm 2026 11 02 / ODOO-350612 (live -67: у кнопки панели страниц x=0 — левая сторона обводки уходила за экран): рамка — цель + зазор 4px,
// но в пределах окна (vw × vh); у края зазор съедается, обводка остаётся видимой
export function guideTarget_markRect(r, vw = 1280, vh = 800, gap = 4) {
    const left = Math.max(0, r.left - gap), top = Math.max(0, r.top - gap)
    const right = Math.min(vw || Infinity, r.right + gap), bottom = Math.min(vh || Infinity, r.bottom + gap)
    return { left, top, width: Math.max(0, right - left), height: Math.max(0, bottom - top) }
}
// тёмная тема приложения — filter: invert(1) на .dark-theme (App.vue); рамка и подсказка живут в body вне инвертированного корня,
// поэтому подсказка оставалась белой — цвета тёмной темы задаются классом gt-dark
function guideTarget_isDark(doc) {
    try { return !!doc.querySelector?.('.dark-theme') } catch (e) { return false }
}
function setDark(node, dark) {
    const cls = String(node.className || '').split(' ').filter(c => c && c !== 'gt-dark')
    if (dark) cls.push('gt-dark')
    node.className = cls.join(' ')
}
// ODOO-350612: прямоугольник с полем (обводка цели: зазор 4 + рамка 3 + гало 6 — 10px с запасом на тень) — для списка «чужих» при выборе стороны подсказки
const TARGET_PAD = 10
const TARGET_ROOM = 40   // ODOO-350612: запас вокруг чужой цели под её выноску (зазор 22 + хвост) — при первом проходе выбора места
const TIP_NEAR = 48   // ODOO-350612: первый проход — выноска не дальше 48px от цели
const TIP_GAP = 22   // ODOO-350612: выноска дальше обводки с гало (13px) — между ними виден хвост
const pad = (o, d) => ({ left: o.left - d, top: o.top - d, right: o.right + d, bottom: o.bottom + d })
// demo-webscm 2026 11 02 / ODOO-350612 (замечание владельца: выноска «3. Поточна база.» легла на текст шапки «Demo (demo7)» рядом с кнопкой базы): видимый
// ТЕКСТ шапки (#AppTopBar) — «мягкие» препятствия: выноска сначала ищет место, не закрывая его; не нашлось — прежние правила как были. Прямоугольники
// строк текста (Range.getClientRects), без пробельных узлов и без текста внутри своей цели (own — элемент цели); не больше limit
const SOFT_ROOT = '#AppTopBar'
export function guideTarget_softText(doc, own = null, limit = 120) {
    const out = []
    try {
        const root = doc?.querySelector?.(SOFT_ROOT)
        if (!root || typeof doc.createTreeWalker !== 'function' || typeof doc.createRange !== 'function') return out
        const walker = doc.createTreeWalker(root, 4 /* NodeFilter.SHOW_TEXT */)
        const range = doc.createRange()
        for (let n = walker.nextNode(), k = 0; n && out.length < limit && k < 2000; n = walker.nextNode(), k++) {
            if (!str(n.nodeValue).trim()) continue
            if (own && typeof own.contains === 'function' && own.contains(n)) continue
            range.selectNodeContents(n)
            for (const r of range.getClientRects()) {
                if (!(r.width > 1 && r.height > 1)) continue
                out.push({ left: r.left, top: r.top, right: r.right, bottom: r.bottom })
            }
        }
        // ODOO-350612 (devap -107): текст полей шапки (поиск, выпадашки) — значение input / select / textarea, не текстовый узел; видимые — тоже препятствия
        for (const f of root.querySelectorAll?.('input, select, textarea') || []) {
            if (out.length >= limit) break
            if (own && typeof own.contains === 'function' && own.contains(f)) continue
            if (!str(f.value || f.placeholder).trim() || typeof f.getBoundingClientRect !== 'function') continue
            const r = f.getBoundingClientRect()
            if (r.width > 1 && r.height > 1) out.push({ left: r.left, top: r.top, right: r.right, bottom: r.bottom })
        }
    } catch (e) { return out }
    return out
}
// рамка вокруг el и подсказка (text, image); { remove() }. opts.doc — document (тест), opts.win — window.
// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «если были клики при переходе… показывать цифру в кружочке и короткое примечание 1. Кликаем…
// 2. выбираем…»): opts.badge — номер шага маршрута: «n.» перед текстом выноски (с 02.11 — только там, кружка на цели нет) (guidePlay — маршрут
// показа навигатора: стол → страница → виджет → цель; шрифт подсказки крупнее основного — 15px, «тоже и в подсказках»)
// demo-webscm 2026 11 02 / ODOO-350612 (devap -107, тема 9: выноска легла на заголовок «Навігатор»): сам док навигатора (.nav-dock) — препятствие выноски
// во всех проходах, кроме случая, когда цель — внутри дока; дока нет / он скрыт — пусто
const DOCK_SEL = '.nav-dock'
export function guideTarget_dockRects(doc, own = null) {
    try {
        const d = doc?.querySelector?.(DOCK_SEL)
        if (!d || typeof d.getBoundingClientRect !== 'function') return []
        if (own && own.nodeType === 1 && typeof d.contains === 'function' && d.contains(own)) return []   // группа (рейка) — не Node: contains бросил бы, а она и не в доке
        const r = d.getBoundingClientRect()
        return r.width > 0 && r.height > 0 ? [{ left: r.left, top: r.top, right: r.right, bottom: r.bottom }] : []
    } catch (e) { return [] }
}
// demo-webscm 2026 11 03 / ODOO-350612 (dm: выноска «Мова» легла на открытое меню пользователя): цель внутри открытого меню (MenuPanel .menu-panel) —
// панель меню жёсткое препятствие, как док: выноска встаёт сбоку от панели, не на её пункты
const MENU_SEL = '.menu-panel'
export function guideTarget_menuRects(el) {
    try {
        const m = el && typeof el.closest === 'function' ? el.closest(MENU_SEL) : null
        if (!m || typeof m.getBoundingClientRect !== 'function') return []
        const r = m.getBoundingClientRect()
        return r.width > 0 && r.height > 0 ? [{ left: r.left, top: r.top, right: r.right, bottom: r.bottom }] : []
    } catch (e) { return [] }
}
export function guideTarget_mark(el, opts = {}) {
    const doc = opts.doc || globalThis.document
    const win = opts.win || globalThis.window
    if (!el || !doc || typeof doc.createElement !== 'function' || typeof el.getBoundingClientRect !== 'function') return null
    ensureStyle(doc)
    const box = doc.createElement('div')
    box.className = 'guide-tour-mark' + (opts.pulse === false ? '' : ' gtm-pulse')
    box.setAttribute('data-guide-tour', '1')
    // ODOO-350612: номер шага маршрута — только в выноске («2. текст»), не кружком на цели (кружок закрывал иконку маленькой кнопки); без текста — выноска с одним номером
    const badgeN = Number(opts.badge) > 0 ? String(Math.floor(Number(opts.badge))) : ''
    let tip = null, tail = null
    if (str(opts.text) || str(opts.image) || badgeN) {
        tip = doc.createElement('div')
        tip.className = 'guide-tour-tip'
        tip.setAttribute('role', 'note')
        tip.setAttribute('data-guide-tour', '1')
        if (str(opts.text) || badgeN) {
            const p = doc.createElement('div')
            if (badgeN) { const n = doc.createElement('b'); n.className = 'guide-tour-tip-n'; n.textContent = badgeN + '.'; p.appendChild(n); if (str(opts.text)) { const tx = doc.createElement('span'); tx.textContent = str(opts.text); p.appendChild(tx) } }
            else p.textContent = str(opts.text)
            tip.appendChild(p)
        }
        if (str(opts.image)) { const img = doc.createElement('img'); img.src = str(opts.image); img.alt = ''; tip.appendChild(img) }
        // demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «Давай на шагах крестики для закрытия»): × в правом верхнем углу выноски — снимает эту
        // подсказку (рамку цели, хвост, выноску), остальные остаются; кнопка — <button> (Tab / Enter / Space), подпись — opts.closeLabel (язык интерфейса)
        if (opts.closable !== false) {
            const x = doc.createElement('button')
            x.className = 'guide-tour-tip-x'
            x.setAttribute('type', 'button')
            x.setAttribute('aria-label', str(opts.closeLabel) || 'Close hint')
            x.setAttribute('title', str(opts.closeLabel) || 'Close hint')
            x.textContent = '×'
            x.onclick = () => { if (handle) handle.close('x') }
            tip.appendChild(x)
            tip.className += ' gt-closable'
        }
    }
    const body = doc.body
    body.appendChild(box)
    if (tip) { tail = doc.createElement('div'); tail.className = 'guide-tour-tail'; tail.setAttribute('data-guide-tour', '1'); body.appendChild(tail); body.appendChild(tip) }
    let handle = null   // ODOO-350612: place() ищет себя в marks — объявлено до первого вызова
    const place = () => {
        if (!el.isConnected) { box.style.display = 'none'; if (tip) { tip.style.display = 'none'; tail.style.display = 'none' } return }
        const r = el.getBoundingClientRect()
        const hidden = !(r.width > 0 && r.height > 0)
        box.style.display = hidden ? 'none' : ''
        const vw = win?.innerWidth || 1280, vh = win?.innerHeight || 800
        const m = guideTarget_markRect(r, vw, vh)   // ODOO-350612: зазор 4px — обводка не ложится на край цели; у края окна — в пределах экрана
        box.style.left = m.left + 'px'; box.style.top = m.top + 'px'; box.style.width = m.width + 'px'; box.style.height = m.height + 'px'
        const dark = guideTarget_isDark(doc)   // ODOO-350612: тема может смениться, пока подсветка висит — класс обновляется каждым тактом
        setDark(box, dark)
        if (tip) {
            setDark(tip, dark)
            tip.style.display = hidden ? 'none' : ''
            const size = { w: tip.offsetWidth || 280, h: tip.offsetHeight || 60 }
            // ODOO-350612: «чужие» — цели ДРУГИХ подсветок (все, с полем обводки: выноска поиска не ложится на кнопку чатов рядом) и выноски ПРЕЖНИХ
            // (новая не ложится на них); место — свободное рядом с целью (tipPos), иначе — сдвиг вниз под занятые (tipAvoid, своя цель тоже занята)
            // сначала вплотную к цели и с запасом вокруг СЛЕДУЮЩИХ целей (TARGET_ROOM — место под их выноску с хвостом: выноска поиска не занимает место под
            // соседней кнопкой чатов, которую разместят после); не нашлось — с полем одной обводки и дальше от цели
            const targets = [], tips = []
            let later = false
            for (const h of marks) {
                if (h === handle) { later = true; continue }
                if (!h.el || h.el === el || !h.el.isConnected) continue
                const o = h.el.getBoundingClientRect(); if (o.width > 0 && o.height > 0) targets.push({ o, later })
            }
            for (const h of marks) { if (h === handle) break; const t = h.tip; if (t && t.style.display !== 'none' && t.isConnected && typeof t.getBoundingClientRect === 'function') tips.push(t.getBoundingClientRect()) }
            const dock = [...guideTarget_dockRects(doc, el), ...guideTarget_menuRects(el)]   // ODOO-350612 (devap -107): док навигатора — жёсткое препятствие (кроме цели в доке); + панель меню цели
            const near = (room) => [...targets.map(x => pad(x.o, room && x.later ? TARGET_ROOM : TARGET_PAD)), ...tips, ...dock]
            // ODOO-350612: нулевой проход — ещё и не закрывая текст шапки (мягкие препятствия); места нет — прежние проходы без изменений
            // devap -107 (тема 2: выноска у кнопки столов легла на «Дистрибуція»): вплотную места нет (рейка с запасом под её выноску) — ещё проход с текстом
            // шапки, полем одной обводки и дальше от цели, прежде чем текстом пожертвовать
            const soft = opts.softText === false ? [] : guideTarget_softText(doc, el)
            let p = soft.length ? guideTarget_tipPos(r, size, opts.placement, vw, vh, TIP_GAP, [...near(true), ...soft], tips, TIP_NEAR) : { busy: true }
            if (p.busy && soft.length) p = guideTarget_tipPos(r, size, opts.placement, vw, vh, TIP_GAP, [...near(false), ...soft], tips)
            if (p.busy) p = guideTarget_tipPos(r, size, opts.placement, vw, vh, TIP_GAP, near(true), tips, TIP_NEAR)
            if (p.busy) p = guideTarget_tipPos(r, size, opts.placement, vw, vh, TIP_GAP, near(false), tips)
            p = guideTarget_tipAvoid(p, size, [...near(false), pad(r, TARGET_PAD)], vh)
            tip.style.left = p.left + 'px'; tip.style.top = p.top + 'px'
            const tl = hidden ? null : guideTarget_tailPts(r, { left: p.left, top: p.top, w: size.w, h: size.h })   // хвост к своей цели
            tail.style.display = tl ? '' : 'none'
            if (tl) { tail.style.left = tl.left + 'px'; tail.style.top = tl.top + 'px'; tail.style.width = tl.width + 'px'; tail.style.height = tl.height + 'px'; tail.style.clipPath = tl.clip }
        }
    }
    // demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «когда пользователь нажимает целевую кнопку тоже закрывать плашку»): нажатие ПОЛЬЗОВАТЕЛЯ по цели
    // (или внутри неё) снимает её подсказку — общий слушатель документа (hubOn), ничего не отменяет (без preventDefault / stopPropagation), снимает ПОСЛЕ
    // того, как нажатие дошло до цели (pointerdown взводит, pointerup / click снимают через setTimeout). Только isTrusted: программный el.click() тура
    // (guideTarget_click, open_cell_passport auto) подсказку не снимает. Цель, которая перестраивается по нажатию (выпадашка, ячейка грида) и до click
    // уходит из DOM, — снимается по pointerup, раз нажатие началось на ней
    const closeOnTarget = opts.closeOnTarget !== false && typeof doc.addEventListener === 'function'
    if (closeOnTarget) hubOn(doc)
    // ODOO-350612 (слово владельца: «Приглушаем после прохождения шага или закрытия сообщения. Можно нажать на приглушённый и подсказка снова всплывает»):
    // id — ключ подсказки для повторного показа (guideTarget_reshow); close(reason) — закрыл ПОЛЬЗОВАТЕЛЬ (× / нажатие по цели): снять и сообщить opts.onClose
    // (тур приглушает строку шага в доке); remove() — снятие туром / доком, без onClose
    const id = ++markSeq
    remember(id, el, opts)
    let removed = false
    handle = {
        id, el, box, tip, tail, badge: badgeN, place, doc, win, closeOnTarget, armed: false, closeT: null, closable: !!tip && opts.closable !== false,   // ODOO-350612: closable — Escape
        hit(t) { return !!t && (t === el || (typeof el.contains === 'function' && !!el.contains(t))) },
        closeSoon(ms) {
            if (handle.closeT) clearTimeout(handle.closeT)
            handle.closeT = setTimeout(() => { handle.closeT = null; handle.close('target') }, ms)
        },
        close(reason) {
            const was = marks.has(handle)
            handle.remove()
            if (was && typeof opts.onClose === 'function') { try { opts.onClose(reason, handle) } catch (e) { /* подписчик упал — подсказка всё равно снята */ } }
        },
        remove() {
            if (handle.closeT) { clearTimeout(handle.closeT); handle.closeT = null }
            if (!removed) { removed = true; if (closeOnTarget) hubOff(doc) }
            try { box.remove() } catch (e) { /* no-op */ } try { tip && tip.remove(); tail && tail.remove() } catch (e) { /* no-op */ } marks.delete(handle)
            if (!marks.size) loopStop()
        },
    }
    marks.add(handle)
    loopStart(opts.everyMs || 400)
    loop.key = ''   // новая цель — следующий такт раскладывает всех
    for (const h of marks) { try { h.place() } catch (e) { /* чужая подсветка уже снята */ } }   // ODOO-350612: появилась новая цель — прежние подсказки тут же уходят с неё, не через такт
    return handle
}
// ODOO-350612: повторный показ подсказки по id (нажатие по приглушённой строке шага в доке): та же цель и те же opts (onClose — тот же подписчик);
// подсказка ещё на экране — она же; цели уже нет в DOM / id неизвестен — null. Помнятся последние MARKS_KEEP подсказок
export function guideTarget_reshow(id) {
    for (const h of marks) if (h.id === id) return h
    const m = shown.get(id)
    if (!m || !m.el || m.el.isConnected === false) return null
    return guideTarget_mark(m.el, m.opts)
}
// снять все подсветки тура (следующий шаг, ✕ полосы, конец тура); число снятых
export function guideTarget_clearMarks() {
    let n = 0
    for (const h of [...marks]) { h.remove(); n++ }
    return n
}
export function guideTarget_marksCount() { return marks.size }

export default { guideTarget_idleStats, guideTarget_softText, guideTarget_dockRects, guideTarget_menuRects, guideTarget_groupEl, guideTarget_tipAvoid, guideTarget_findWidget, guideTarget_widgetEl, guideTarget_grid, guideTarget_findRow, guideTarget_findCol, guideTarget_cell, guideTarget_openTab,
    guideTarget_chipEl, guideTarget_resolve, guideTarget_click, guideTarget_tipPos, guideTarget_tailPts, guideTarget_markRect, guideTarget_mark, guideTarget_clearMarks, guideTarget_marksCount, guideTarget_reshow,
    guideTarget_openPassport, guideTarget_tagBtn, guideTarget_onlyByButton, // IE 2026 10 13 / ODOO-343435
    guideTarget_rowKeys, guideTarget_keyCols, guideTarget_periodCol, guideTarget_valueRow }   // IE 2026 10 08 / ODOO-343435
